import useTranslate from 'app/i18n/useTranslate';

import type { MixOrderIssueCode } from 'hooks/useMixOrderAdvisory/types';

const useTranslation = () => {
    const t = useTranslate('mixOrderAdvisoryPanel');

    return {
        EMPTY_MESSAGE: t('emptyMessage'),
        ERROR_MESSAGE: t('errorMessage'),
        ISSUES_TITLE: t('issuesTitle'),
        LOADING: t('loading'),
        TITLE: t('title'),
        UNKNOWN_FORMULATION: t('unknownFormulation'),
        groupHeader: (order: number, label: string): string =>
            t('groupHeader', { label, order: String(order) }),
        groupLabel: (order: number): string => {
            const key = `groupLabels.${order}`;
            const label = t(key);
            const isMissing = label === key || label.endsWith(`.${key}`);

            return isMissing ? t('unknownGroup', { order: String(order) }) : label;
        },
        issueCodeTitle: (code: MixOrderIssueCode): string => t(`issueCodeTitles.${code}`)
    };
};

export default useTranslation;
